<script setup lang="ts">
import { defineProps } from 'vue'
const { customer } = defineProps(['customer'])



function formatDate(dateString: string) {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  // Format the date using the user's default locale and specified options
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'medium', // Example: "March 24, 2021"
    timeStyle: 'medium', // Example: "1:00:00 PM",
    timeZone: 'America/Sao_Paulo',
  }).format(date);
}

// Para coluna `date`, sem hora (ex.: awared_at, awared_until). O `formatDate` acima leria "2026-09-29" como
// meia-noite UTC e, no fuso de São Paulo, mostraria o dia anterior.
function formatDay(dateString: string) {
  if (!dateString) {
    return '';
  }
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
}

function isBeforeToday(dateString: string) {
  if (!dateString) {
    return;
  }
  const date = new Date(dateString);
  const now = new Date();
  date.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  if (date < now) {
    return true
  }
}

</script>

<template>
  <form v-if="customer?.id" class="w-full max-w-xs bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
    <div class="mb-4" v-if="customer?.enrichment_at">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Ultima Pesquisa de dados: {{ formatDate(customer.enrichment_at) }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Cliente: {{ customer.name }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Unidade: {{ customer.company.name }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        CPF: {{ customer.document }}
      </label>
    </div>
    <div class="mb-4" v-if="customer?.scheduled_at && customer.absentee && !isBeforeToday(customer?.scheduled_at)">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Tem consulta em algum dos tratamentos marcada para: {{ formatDate(customer.scheduled_at) }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Faltou na consulta hoje: {{ customer.absentee ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Sem Agenda em um ou mais tratamentos: {{ customer.unscheduled ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Atraso em até 21 dias: {{ customer.recent_debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Em Atraso a mais 21 dias: {{ customer.debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
         Pré-Negativado: {{ customer.pre_old_debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Negativado: {{ customer.old_debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Negativado a mais de 2 anos: {{ customer.very_old_debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Aniversariante: {{ customer.birthday  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Pós-Venda: {{ customer.post_sales  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <!-- Só enquanto a previsão vale: `awared` é o mesmo Customer#current_awared? que segura o
         torpedo de voz, então a tela e as ligações concordam sobre quando ela venceu. -->
    <div class="mb-4" v-if="customer?.awared">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Previsão de pagamento até: {{ formatDay(customer.awared_until) }}
        <span v-if="customer.awared_at">(informada em {{ formatDay(customer.awared_at) }})</span>
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Soliciou Renegociar/Falar com Atendente hoje: {{ customer.not_disturb  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Judicial: {{ customer.judicial_debit  ? 'Sim' : 'Não' }}
      </label>
    </div>
    <div class="mb-4" v-if="customer.defaulted">
      <label class="block text-gray-700 text-sm font-bold mb-2">
        Em Débito: Sim
      </label>
    </div>
  </form>
</template>
